(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/leaguebig/assets/javascripts/views/league-big-statistics-tabs.js') >= 0) return;  svs.modules.push('/components/statistics/leaguebig/assets/javascripts/views/league-big-statistics-tabs.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.views = svs.statistics.big.views || {};

  svs.statistics.big.views.LeagueBigStatisticsTabs = Backbone.Marionette.View.extend(
    {
      template: function() {
        return '';
      },
      modelEvents: {
        change: 'render'
      },
      log: new svs.core.log.Logger('svs.statistics.LeagueBigStatisticsTabs'),
      initialize: function() {
        this.model = this.options.model;

        if (_.has(this.options, 'bigNavRef')) {
          this.bigNavRef = this.options.bigNavRef;
        }

        if (_.isObject(this.model)) {
          this.leagueId = this.model.get('leagueId');
        }

        this.listenTo(this, 'resize', this.resizeRoyalSlider);
      },
      onRender: function() {
        this.renderContent();
      },
      cloneModels: function() {
        this.leagueModelClone1 = new svs.statistics.models.League({
          leagueId: this.leagueId
        });
        this.leagueModelClone1.attributes = _.deepClone(this.model.attributes);

        this.leagueModelClone2 = new svs.statistics.models.League({
          leagueId: this.leagueId
        });
        this.leagueModelClone2.attributes = _.deepClone(this.model.attributes);

        this.leagueModelClone3 = new svs.statistics.models.League({
          leagueId: this.leagueId
        });
        this.leagueModelClone3.attributes = _.deepClone(this.model.attributes);
      },
      renderContent: function() {
        if (
          _.isObject(this.model) &&
          !this.model.get('league') &&
          !this.options.preDraw
        ) {
          return;
        }

        if (_.isObject(this.model)) {
          this.cloneModels();
        }
        this.disposeSubviews();

        this.setupTabs();

        this.selectedTab = this.options.selectedTab
          ? this.options.selectedTab
          : 'tabell';

        this.statsTab = new svs.app.tab_view.TabView({
          tabs: this.tabs,
          selected: this.selectedTab,
          path: false,
          sliderOptions: {
            thumbs: { spacing: 0, transitionSpeed: 200 },
            fadeinLoadedSlide: false,
            sliderDrag: svs.core.detect.formfactor.desktop() ? false : true 
          },
          cacheCreated: true,
          cssClass: 'rsInverted-large'
        });

        var _self = this;
        this.statsTab.on('onChange', function() {
          $(window.document).trigger('resizeMultiSwiper');
          _self.resizeRoyalSlider();
        });
        this.$el.html(this.statsTab.el);
      },

      setupTabs: function() {
        this.tabs.push({
          caption: 'Spelschema',
          view: new svs.statistics.views.StatLeagueGames({
            params: {
              league: this.leagueModelClone1,
              leagueId: this.leagueId,
              sportId:
                _.isObject(this.model) && _.isObject(this.model.get('league'))
                  ? this.model.get('league').sport.id
                  : null,
              parent: this,
              bigNavRef: this.bigNavRef,
              preDraw: this.options.preDraw
            }
          }),
          id: 'matcher',
          cssClass: 'slide-inverted'
        });
        if (!_.isObject(this.model)) {
          return;
        }
        if (
          this.model.get('league').sport.id !== svs.statistics.constants.TENNIS
        ) {
          this.tabs.unshift({
            caption: 'Tabell',
            view: new svs.statistics.views.StatGeneralTables({
              params: {
                league: this.leagueModelClone3,
                leagueId: this.leagueId,
                parent: this
              }
            }),
            id: 'tabell',
            cssClass: 'slide-inverted'
          });
          this.tabs.push({
            caption: 'Statistik',
            view: new svs.statistics.views.StatLeagueStatistics({
              params: {
                league: this.leagueModelClone2,
                leagueId: this.leagueId,
                parent: this,
                preDraw: this.options.preDraw
              }
            }),
            id: 'statistik',
            cssClass: 'slide-inverted'
          });
        }
      },

      resizeRoyalSlider: function() {
        if (_.isObject(this.statsTab)) {
          this.statsTab.resize();
        }
      },
      disposeSubviews: function() {
        _.each(this.tabs, function(viewCache) {
          viewCache.view.destroy();
        });
        this.tabs = [];
      },
      onDestroy: function() {
        this.stopListening();
        this.disposeSubviews();
        this.clearServerFetchedData();

        if (this.model) {
          this.model.off();
        }

        if (this.statsTab) {
          this.statsTab.off();
        }

        if (_.isObject(this.statsTab)) {
          this.statsTab.destroy();
        }

        if (this.model) {
          this.model.dispose();
          this.model.stopListening();
          this.model = null;
          delete this.model;
        }

        this.options.model = null;
        this.options = null;
        this.tabs = null;
        this.statsTab = null;

        delete this.options;
        delete this.tabs;
        delete this.statsTab;

        this.model = null;
        delete this.model;

        this.leagueModelClone1 = null;
        delete this.leagueModelClone1;

        this.leagueModelClone2 = null;
        delete this.leagueModelClone2;

        this.leagueModelClone3 = null;
        delete this.leagueModelClone3;

        this.bigNavRef = null;
        delete this.bigNavRef;
        this.leagueId = null;
        delete this.leagueId;
      },
      clearServerFetchedData: function() {
        if ((((svs.statistics || {}).data || {}).leagueModels || {}).matches) {
          svs.statistics.data.leagueModels.matches = null;
        }

        if (
          (((svs.statistics || {}).data || {}).leagueModels || {}).statistics
        ) {
          svs.statistics.data.leagueModels.statistics = null;
        }

        if (
          (((svs.statistics || {}).data || {}).leagueModels || {}).leaguetables
        ) {
          svs.statistics.data.leagueModels.leaguetables = null;
        }

        if (
          (((svs.statistics || {}).data || {}).teamModels || {}).leaguetables
        ) {
          svs.statistics.data.teamModels.leaguetables = null;
        }

        if (
          (((svs.statistics || {}).data || {}).matchModels || {}).leaguetables
        ) {
          svs.statistics.data.matchModels.leaguetables = null;
        }
      }
    }
  );
})(Backbone, _, svs);

 })(window);